import './Modal.scss';
import React, { type ReactNode } from 'react';
import 'react-responsive-modal/styles.css';

import { Modal as ModalPkg } from 'react-responsive-modal';

import { IoCloseSharp } from 'react-icons/io5';
import { Button } from 'components/Button/Button';

export type ModalProps = {
    open: boolean;
    setClose: () => void;
    title?: string | null;
    yesText?: string;
    noText?: string;
    onValidate?: () => void;
    onClose?: () => void;
    closeOnValidate?: boolean;
    setCloseOnClose?: boolean;
    isValidateDestructive?: boolean;
    isValidateSubmit?: boolean;
    children?: ReactNode;
    formId?: string;
    className?: string;
};
export const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
    (
        {
            open,
            setClose,
            onClose,
            title,
            yesText,
            noText,
            onValidate,
            closeOnValidate = true,
            setCloseOnClose = true,
            isValidateDestructive: _isValidateDestructive,
            isValidateSubmit = false,
            children,
            formId,
            className
        },
        ref
    ) => {
        return (
            <div ref={ref}>
                <ModalPkg open={open} onClose={setClose} center closeIcon={<IoCloseSharp />}>
                    <div className={`modal ${className}`}>
                        {title && <h2>{title}</h2>}

                        <div className="body">{children}</div>

                        <div className="footer">
                            {onValidate && (
                                <Button
                                    label={yesText ?? 'Oui'}
                                    callback={
                                        isValidateSubmit
                                            ? undefined
                                            : () => {
                                                  onValidate();
                                                  closeOnValidate && setClose();
                                              }
                                    }
                                    type={isValidateSubmit ? 'submit' : 'button'}
                                    form={formId}
                                    className="validate"
                                />
                            )}
                            {onClose && (
                                <Button
                                    label={noText ?? 'Non'}
                                    callback={() => {
                                        setCloseOnClose &&setClose();
                                        onClose();
                                    }}
                                    type="button"
                                    className="close"
                                />
                            )}
                        </div>
                    </div>
                </ModalPkg>
            </div>
        );
    }
);
